//param title, close and save handles, locales
import { AiOutlineProfile } from "react-icons/ai";
import { getInfo, UpdateBeneficiary, GetBeneficiary, GetAccounts, GetAccount, UpdateAccount,CreateAccount } from "../utilities/calls";
import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { address_locales, service_provider_profile, countryLocaleList } from "../utilities/templates";
import { renderField} from "../utilities/functions";
import Tags from "./Tags";
import CopyToClipboard from "./CopyToClipboard";
import ImageInputModal from "./ImageInputModal";
import DeleteModal from "./DeleteModal";

export default function BeneProfileForm() {

  const [sent, setSent] = useState(true);
  const [account, setAccount] = useState();
  const [showAlert, setShowAlert] = useState();
  const [alertText, setAlertText] = useState();
  const [showLogoImageModal, setShowLogoImageModal] = useState();
  const [logoImageType, setLogoImageType] = useState('');  
  const [selectedCountry, setSelectedCountry] = useState(
    Intl.NumberFormat().resolvedOptions().locale
  );
  const [showDeleteDlg, setShowDeleteDlg] = useState();
  const[confirmationText, setConfirmationText] = useState();
  const [updatedaddress, updateAddress] = useState({
    name: "",
    description: "",
    categories: "",
    website: "",
    logourl: "",
    apiconnect: "",
    apidomain: "",
    street: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    email: "",
    phone: "",
    addressee: ""
  });
  const [customTags, setCustomTags] = useState([])
  const { spid } = useParams();
  const location = useLocation(); // Get the tags from the state param
  const isReadOnly = location?.state?.readOnly;
  const canConnect = location?.state?.showConnect;
  const getBene = useCallback((id) => {
    let tags = {};
    GetBeneficiary(id).then((resp) => {
      const ben = {
        name: resp.tags.name?.Value, description: resp.tags.description?.Value, categories: resp.tags.categories?.Value, website: resp.tags.website?.Value, logourl: resp.tags.logourl?.Value, apiconnect: resp.tags.apiconnect?.Value, apidomain: resp.tags.apidomain?.Value, street: resp.tags.street?.Value,
        addressee: resp.tags.addressee?.Value,
        city: resp.tags.city?.Value,
        state: resp.tags.state?.Value,
        zipCode: resp.tags.zipCode?.Value,
        country: resp.tags.country?.Value,
        phone: resp.tags.phone?.Value,
        email: resp.tags.email?.Value
      };
      if(resp.tags.logofile) {
        ben.logofile = resp.tags.logofile.Value
        ben.logofilename = resp.tags.logofilename?.Value
      }
      updateAddress(ben)
      var keys = Object.keys(ben).map((key) => { return key.toLowerCase() });

      Object.keys(resp.tags).forEach((tag) => {
        var name = resp.tags[tag].Name;
        if (keys.indexOf(name.toLowerCase()) === -1)
          tags[tag] = resp.tags[tag];
      })
      setCustomTags(tags);
    }).catch((err) => { console.log("Error fetching beneficiary details", err) })

  }, []);
  useEffect(() => {
    GetAccounts().then((response) => {
      if(Object.keys(response).length === 0 ){
        CreateAccount("", {}, {}, {}).then((response) => { 
           setAccount(response);
         }).catch((err) => { console.log(err);})
       } else {
      Object.keys(response).forEach((key, index) => {
        GetAccount(key).then((accDetails) => {
          setAccount(accDetails);
        }).catch((error) => {
          console.log("Error in Get Account details", error);
        });
      })}
    }).catch((error) => {
      console.error("Error fetching accounts:", error);
      setShowAlert(true);
      setAlertText("Error fetching data from server. Please try again!");
    });
    if (spid.localeCompare("00000000-0000-0000-0000-000000000000") !== 0)
      getBene(spid);
  }, [getBene, spid]);


  const getMergedData = () => {
    var mergedData = {
      tags: {
        name: {
          Name: "name",
          Value: updatedaddress?.name,
          Private: false,
          Required: false,
          Editable: false,
        },
        description: {
          Name: "description",
          Value: updatedaddress?.description,
          Private: false,
          Required: false,
          Editable: false
        },
        categories: {
          Name: "categories",
          Value: updatedaddress?.categories,
          Private: false,
          Required: false,
          Editable: false
        },
        website: {
          Name: "website",
          Value: updatedaddress?.website,
          Private: false,
          Required: false,
          Editable: false
        },
        apidomain: {
          Name: "apidomain",
          Value: updatedaddress?.apidomain,
          Private: false,
          Required: false,
          Editable: false
        },
        addressee: {
          Name: "addressee",
          Value: updatedaddress?.addressee,
          Private: false,
          Required: false,
          Editable: false
        },
        street: {
          Name: "street",
          Value: updatedaddress?.street,
          Private: false,
          Required: false,
          Editable: false,
        },
        city: {
          Name: "city",
          Value: updatedaddress?.city,
          Private: false,
          Required: false,
          Editable: false
        },
        state: {
          Name: "state",
          Value: updatedaddress?.state,
          Private: false,
          Required: false,
          Editable: false
        },
        zipCode: {
          Name: "zipCode",
          Value: updatedaddress?.zipCode,
          Private: false,
          Required: false,
          Editable: false
        },
        email: {
          Name: "email",
          Value: updatedaddress?.email,
          Private: false,
          Required: false,
          Editable: false
        },
        phone: {
          Name: "phone",
          Value: updatedaddress?.phone,
          Private: false,
          Required: false,
          Editable: false
        },
        __SYS_JW_TOS__: {
          Name: "Terms of Service",
          Value: true,
          Private: true,
          Required: true,
          Editable: false,
        }
      }
    }
    if(updatedaddress.logourl){ 
      mergedData.tags.logourl = {
          Name: "logourl",
          Value: updatedaddress?.logourl,
          Private: false,
          Required: false,
          Editable: false
        }
      } else {
        mergedData.tags.logofile = {
          Name: "logofile",
          Value: updatedaddress?.logofile,
          Private: false,
          Required: false,
          Editable: false
        };
        mergedData.tags.logofilename = {
          Name: "logofilename",
          Value: updatedaddress?.logofilename,
          Private: false,
          Required: false,
          Editable: false
        }
      }
    return mergedData;
  }

  const addCustomTag = (tag, key) => {
    var tagname = key ? key : tag.Name;
    setCustomTags((prevValues) => ({
      ...prevValues, [tagname]: tag
    }))
    setSent(false);
  }

  const removeCustomTag = (tagName) => {
    var newMap = {...customTags};
    delete newMap[tagName]
    setCustomTags({...newMap} )
    setSent(false);
  }

  const saveSP = (mergedData) => {
    UpdateBeneficiary(spid, mergedData)
      .then((response) => {
        setShowAlert(true);
        setAlertText("Beneficiary updated!");
        setSent(true);
        getBene(spid);
      })
      .catch((error) => {
        console.error("Error UPDATING beneficiary details:", error);
        setShowAlert(true);
        setAlertText("Save beneficiary profile failed! Sorry!");
      });
  }
  const addServiceProviderAndSaveSP = (mergedData) => {
    const individualid = getInfo("IndividualID");
    let serviceProviders = account.ServiceProviders || {};
    let beneficiary = account.Beneficiaries || {};
    beneficiary["00000000-0000-0000-0000-000000000000"] = true;

    UpdateAccount(account.id, individualid, {}, serviceProviders, beneficiary).then((response) => {
      let oldSps = Object.keys(account.Beneficiaries);
      let spid = Object.keys(response.Beneficiaries).find((el) => oldSps.indexOf(el) === -1);
      UpdateBeneficiary(spid, mergedData).then((response) => {
        setShowAlert(true);
        setAlertText("Beneficiary added!");
        setSent(true);
        getBene(spid);
      })
        .catch((error) => {
          console.error("Error UPDATING beneficiary details:", error);
          setShowAlert(true);
          setAlertText("Save beneficiary profile failed! Sorry!");
        });
    }).catch((error) => { console.log("Error in updateAccount", error) })
  }

  const processForm = () => {
    var mergedData = getMergedData();
    mergedData.tags = { ...mergedData.tags, ...customTags }
    if (spid.localeCompare("00000000-0000-0000-0000-000000000000") !== 0)
      saveSP(mergedData);
    else {
      addServiceProviderAndSaveSP(mergedData)
    }
  };

  const handleInputChange = (e) => {
     if(e.target.name === "logourl_url"){
      setLogoImageType('url');
      setShowLogoImageModal(true);
    } else if (e.target.name === "logourl_file") {
      setLogoImageType('upload');
      setShowLogoImageModal(true);
    } else {
    if (e.target.name === "country") {
      handleCountryChange(e);
      return;
    }
    const { name, value } = e.target;
    updateAddress((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  }
    setSent(false);
  };

  const handleDelete = () => {
    setConfirmationText('Are you sure you want to delete this logo image?')
    setShowDeleteDlg(true);
  }

  const deleteLogo = () => {
    updateAddress((prevValues) => {
      const updated = {
        ...prevValues,
        logourl: "",
      };
      delete updated.logofile;
      delete updated.logofilename;
      return updated;
    });
    setShowDeleteDlg(false)
    setSent(false)
  }

  const updateLogoImage = (type,image,name) => {
    if (type === 'url') {
  updateAddress((prevValues) => {
    const updated = {
      ...prevValues,
      logourl: image,
    };
    delete updated.logofile;       // Remove logofile when type is url
    delete updated.logofilename;   // Also remove logofilename
    return updated;
  });
} else {
  updateAddress((prevValues) => {
    const updated = {
      ...prevValues,
      logofile: image,
      logofilename: name,
    };
    delete updated.logourl;        // Remove logourl when type is not url
    return updated;
  });
}
   setShowLogoImageModal(false)
  }

  const handleCountryChange = (e) => {
    const countryVal = countryLocaleList.find(
      (o) => o.name === e.target.value
    ).value;
    updateAddress((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
    }));
    setSent(false);

    setSelectedCountry(countryVal);
  };

  function handleAccordionClick(ev) {
    let dv, icon;
    if (ev.target.dataset && ev.target.dataset.accordionTarget) {
      dv = document.getElementById(ev.target.dataset.accordionTarget);
      icon = ev.target.querySelector("svg");
    } else {
      const button = ev.target.closest("button");
      dv = document.getElementById(button.dataset.accordionTarget);
      icon = button.querySelector("svg");
    }
    if (dv.classList.contains("hidden")) {
      dv.classList.add("block");
      dv.classList.remove("hidden");
      icon.classList.remove("rotate-180");
    } else {
      dv.classList.add("hidden");
      dv.classList.remove("block");
      icon.classList.add("rotate-180");
    }
  }

  return (
    <div style={{ marginTop: "20px", marginLeft: "20px" }}>
      <div className="mx-auto max-w-screen-lg form-container p-5">
        <div>
          <h1 className="form-label">
            <AiOutlineProfile className="inline-icon" />
            Beneficiary Details
          </h1>
          {spid && spid.localeCompare("00000000-0000-0000-0000-000000000000") !== 0 ? <><h1 id="benId">{spid}</h1><CopyToClipboard elId="benId" /></> : <></>}
          {spid && spid.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? <h4 className="text-sm py-2">Your business details will be visible to the JustWhere community.</h4> : <></>}
        </div>

        <div id="accordion-collapse" data-accordion="collapse" className="p-5">
          <h2 id="accordion-collapse-heading-1">
            <button type="button" className="flex items-center justify-between w-full p-5 font-medium rtl:text-right border border-b-0 gap-3" data-accordion-target="accordion-collapse-body-1" onClick={handleAccordionClick}>
              <span>Services Details </span>
              <svg data-accordion-icon class="rotate-180 w-3 h-3 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
              </svg>
            </button>
          </h2>
          <div id="accordion-collapse-body-1" aria-labelledby="accordion-collapse-heading-1">
            <div class="p-5 border border-grey-700">
              <fieldset disabled={isReadOnly ? "disabled" : ""}>

                {service_provider_profile.map((element) => {
                  return renderField(element.label, element.id, element.type, updatedaddress[element.id], handleInputChange, element.options,element.tooltip,isReadOnly,element.placeholdertext, element.id1, updatedaddress[element.id1], handleDelete);
                })
                }
              </fieldset>
            </div>
          </div>
          <h2 id="accordion-collapse-heading-2">
            <button type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right border border-b-0 gap-3" data-accordion-target="accordion-collapse-body-2" onClick={handleAccordionClick}>
              <span>Address Details</span>
              <svg data-accordion-icon class="rotate-180 w-3 h-3 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
              </svg>
            </button>
          </h2>
          <div id="accordion-collapse-body-2" class="hidden" aria-labelledby="accordion-collapse-heading-2">
            <div class="p-5 border border-grey-700">
              <fieldset disabled={isReadOnly ? "disabled" : ""}>

                {address_locales[selectedCountry]
                  ? address_locales[selectedCountry].map((element) => {
                    return renderField(element.label, element.id, element.type, updatedaddress[element.id], handleInputChange, element.options);
                  })
                  : address_locales["default"].map((element) => {
                    return renderField(element.label, element.id, element.type, updatedaddress[element.id], handleInputChange, element.options);
                  })}
              </fieldset>
            </div>
          </div>
          <h2 id="accordion-collapse-heading-3">
            <button type="button" className="flex items-center justify-between w-full p-5 font-medium rtl:text-right border gap-3" data-accordion-target="accordion-collapse-body-3" onClick={handleAccordionClick}>
              <span>More Details </span>
              <svg data-accordion-icon class="rotate-180 w-3 h-3 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
              </svg>
            </button>
          </h2>
          <div id="accordion-collapse-body-3" class="hidden" aria-labelledby="accordion-collapse-heading-3">
            <div class="p-5 border border-grey-700">
              <fieldset disabled={isReadOnly ? "disabled" : ""}>

                <div className="py-5"><Tags isReadOnly={isReadOnly} saveFn={addCustomTag} tags={customTags} deleteFn={removeCustomTag} /></div>

              </fieldset>
            </div>

          </div>

        </div>
        {

          spid.localeCompare("00000000-0000-0000-0000-000000000000") === 0 &&

          <div className="p-5">

            <a href="#/policies/beneficiaryPolicy" style={{ display: sent ? "none" : "block" }} target="_blank" rel="noopener noreferrer" className="px-2"> By clicking on ADD you agree to the JustWhere <span className="text-blue-400">{" "}Terms of Service for Beneficiary</span></a>

          </div>

        }


        <section className="flex flex-start gap-2 py-2">
          {
            canConnect ?  <Link to={`/contactBeneficiary/${spid}`} state={{previousPage: `/AddBeneficiaryProfile/${spid}` , readOnly:true}}><button 
                    className="button-style"
                >
                    Connect
                </button></Link> : <></>
          }
          <button style={{ width: "fit-content", display: sent ? "none" : "block", }} formMethod="dialog" formTarget="top" type="submit" onClick={processForm} id="btn-address-add-submit" form="form-address-new" className="button-style positive-action">
            {spid.localeCompare("00000000-0000-0000-0000-000000000000") !== 0 ? "UPDATE" : "ADD"}
          </button>

          {!sent ? (
            <Link to={location.state.previousPage}>
              <button className="button-style">Cancel</button>
            </Link>
          ) : (
            <Link to={location.state.previousPage || "/"}>
              <button className="button-style">Close</button>
            </Link>
          )}
          <div class=" col-span-10 bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative w-full" role="alert" style={{ display: showAlert ? "block" : "none" }}>
          <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={()=> {setShowAlert(false)}}>X</button><span class="text-sm">{alertText} </span>
          </div>
        </section>
      </div>
      { showLogoImageModal && <ImageInputModal logourl={updatedaddress.logourl} logofilename={updatedaddress.logofilename} logofile={updatedaddress.logofile} type={logoImageType} onSave={updateLogoImage} onClose={() => setShowLogoImageModal(false)}/>}
      <DeleteModal confirmationText={confirmationText} deleteLabel="Delete" onDeleteFn={deleteLogo} onCancelFn={()=>{setShowDeleteDlg(false)}} show={showDeleteDlg}/>
    </div >
  );
}


